<div class="container">
  <div class="column primary-column">
    <div class="row header-row">
      <div class="header-title">Base Oil</div>
      @if (canAddRow()) {
      <p
        class="legend right add-button"
        (click)="addRow()"
        title="Add another row"
      >
        +
      </p>
      } @if (canRemoveRow()) {
      <p
        class="legend right remove-button"
        (click)="removeRow()"
        title="Remove row"
      >
        −
      </p>
      }
    </div>
    @for (row of rows; track row; let i = $index) {
    <div class="row number-value">
      <div class="select-container">
        <span class="delete-icon" (click)="clearRowData(i)">✕</span>
        <div class="custom-select-wrapper">
          <input
            type="text"
            class="custom-select-input"
            [formControl]="baseOilControls[i]"
            [matAutocomplete]="auto"
            (blur)="onBaseOilInputBlur(i)"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="onBaseOilSelected($event, i)"
            panelClass="custom-autocomplete-panel"
          >
            <cdk-virtual-scroll-viewport
              itemSize="36"
              class="autocomplete-viewport"
            >
              <mat-option
                *cdkVirtualFor="let option of filteredBaseOils[i]"
                [value]="option"
              >
                {{ option.label }}
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="column secondary-column">
    <div class="row centered">Batch</div>
    @for (row of rows; track row; let i = $index) {
    <div class="row number-value">
      <div class="custom-select-wrapper">
        <input
          type="text"
          class="custom-select-input"
          [formControl]="batchControls[i]"
          [class.batch-unavailable]="isBatchUnavailable(i)"
          [attr.aria-describedby]="isBatchUnavailable(i) ? 'base-oil-batch-warning-' + i : null"
          [matAutocomplete]="batchAuto"
          (input)="onBatchInput(i, $any($event.target).value)"
          (blur)="onBatchInputBlur(i)"
        />
        <mat-autocomplete
          #batchAuto="matAutocomplete"
          (optionSelected)="onBatchSelectedFromAutocomplete($event, i)"
          panelClass="custom-autocomplete-panel"
        >
          <cdk-virtual-scroll-viewport itemSize="36" class="autocomplete-viewport">
            <mat-option
              *cdkVirtualFor="let item of filteredBatches[i]"
              [value]="item.value"
              (mousedown)="$event.preventDefault()"
            >
              {{ item.value }}
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </mat-autocomplete>
      </div>
    </div>
    }
  </div>
  <div class="column secondary-column">                                                                                                                                  
    <div class="row centered">Ratio</div>
    @for (row of rows; track row; let i = $index) {
    <div class="row number-value">
      <input
        type="text"
        inputmode="decimal"
        max="100"
        placeholder=""
        [(ngModel)]="rows[i].ratio1"
        (keydown)="restrictNumericInput($event)"
        (input)="handleRatioInput($event, i, 'ratio1')"
        (blur)="onRatioBlurFormat(i, 'ratio1')"
      />
    </div>
    }
  </div>
  <div class="column secondary-column">
    <div class="row centered">&nbsp;</div>
    @for (row of rows; track row; let i = $index){
    <div class="row number-value">
      <p>{{ rows[i].treat1 }}</p>
    </div>
    }
  </div>
  <div class="column secondary-column">
    <div class="row centered">Ratio</div>
    @for (row of rows; track row; let i = $index){
    <div class="row number-value">
      <input
        type="text"
        inputmode="decimal"
        max="100"
        placeholder=""
        [(ngModel)]="rows[i].ratio2"
        (keydown)="restrictNumericInput($event)"
        (input)="handleRatioInput($event, i, 'ratio2')"
        (blur)="onRatioBlurFormat(i, 'ratio2')"
      />
    </div>
    }
  </div>
  <div class="column secondary-column">
    <div class="row centered">&nbsp;</div>
    @for (row of rows; track row; let i = $index){
    <div class="row number-value">
      <p>{{ rows[i].treat2 }}</p>
    </div>
    }
  </div>
</div>
<div class="batch-warnings" role="status">
  @for (row of rows; track row; let i = $index) {
    @if (isBatchUnavailable(i)) {
      <p [id]="'base-oil-batch-warning-' + i">
        Saved batch unavailable: {{ row.oil }} / {{ row.batch }}
      </p>
    }
  }
</div>
